import Keycloak from 'keycloak-js'
import store from '@/store'
import config from '@/config'
import { initAxios, axiosInstance } from '@/api'

let initOptions = {
  realm: config.keycloak.realm,
  url: config.keycloak.serverUrl,
  clientId: config.keycloak.clientId
}

var keycloak = Keycloak(initOptions)

keycloak.onAuthSuccess = function () {
  console.log(`keycloak.onAuthSuccess: start`)
  keycloak.loadUserProfile()
  .then((profile) => {
    // console.log(profile)
    if (keycloak.token && keycloak.idToken && keycloak.token != '' && keycloak.idToken != '') {
      store.commit("login", [keycloak.token, keycloak.tokenParsed])
      localStorage.isSignIn = 'true'
      initAxios()
      // console.log('keycloak.onAuthSuccess:  set kc.token')
      // axiosInstance({
      //   method: 'get',
      //   url: '/user/self',
      // })
      // .then(response => {
      //   if(response.status === 200) {
      //     if (response.data.suspended === false) {
      //       store.commit("updateSuspended", [false])
      //     } else {
      //       store.commit("updateSuspended", [true])
      //     }
      //   } else {
      //     store.commit("updateSuspended", [true])
      //   }
      // })
      // .catch(error => {
      //   store.commit("updateSuspended", [true])
      // })
      // ### Plane for New User Account Process

      console.log('method get /user/getOrCreate by auth.js')
      axiosInstance({
        method: 'get',
        url: '/user/getOrCreate',
        // data: {
        //   username: profile.username, 
        //   email: profile.email
        // }
      })
      .then(response => {
        console.log('/user/getOrCreate response-code: '+JSON.stringify(response.status, null, 2))
        if(response.status === 200 || response.status === 201) {
          if (response.data.suspended === false) {
            store.commit("updateSuspended", [false])
          } else {
            store.commit("updateSuspended", [true])
          }
        } else {
          store.commit("updateSuspended", [true])
        }
      })
      .catch(error => {
        store.commit("updateSuspended", [true])
      })
    } else {
      // console.log('keycloak.onAuthSuccess:  empty kc.token')
      store.commit("logout")
      localStorage.isSignIn = 'false'
    }
  })
  .catch((error) => {
    console.log(error)
  })
}

keycloak.onTokenExpired = function () {
  keycloak.updateToken()
  .then((refreshed) => {
    if (refreshed) {
        // console.log('Token refreshed: ' + keycloak.token)
        store.commit("updateToken", [keycloak.token])
        initAxios()
    } else {
      console.log('Token not refreshed, valid for ' + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds')
    }
  })
  .catch((error) => {
    console.log(error)
  })
}

export default {
  login () {
    keycloak.init({ checkLoginIframe: false })
    .then((auth) => {
      if (!auth) {
        keycloak.login({ redirectUri: window.location.protocol+'//'+window.location.host+'/pages/callback' })
        // Pass Query String: path to redirectUri and use for redirect back to current page after login by callback 
        // keycloak.login({ redirectUri: window.location.protocol+'//'+window.location.host+'/pages/callback?path='+window.location.pathname })
      } else {
        // console.log('###  login: success ###')
        // ### Move to operate by keycloak.onAuthSuccess ###

        // let resource_access = keycloak.tokenParsed.resource_access
        // console.log("--> log: get username : " + keycloak.subject)
        // console.log("--> log: User has logged in: " + keycloak.subject)
        // console.log("--> log: TokenParsed: " + JSON.stringify(keycloak.tokenParsed))
        // console.log("--> log: User name: " + keycloak.tokenParsed.preferred_username)
        // if (resource_access.hasOwnProperty("ceph-s3-backend")) {
        //   console.log("--> log: Roles: " + JSON.stringify(resource_access["ceph-s3-backend"]))
        //   console.log("--> log: Roles: " + JSON.stringify(resource_access["ceph-s3-backend"].roles))
        // }

      }
    })
    .catch(() => {
      console.log("Authenticated Failed")
    })
  },

  silentCheck () {
    console.log(`!!! silentCheck !!!`)
    keycloak.init({
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
    })
    .then((auth) => {
      if (!auth) {
        // console.log('localStorage is incorrect state. Reset localStorage')
        store.commit("logout")
        localStorage.isSignIn = 'false'
      } else {
        console.log('###  silentLogin: success ###')
        // ### Move to operate by keycloak.onAuthSuccess ###
      }
    })
    .catch(error => {
      console.log(error)
      console.log("Silent Authenticated Failed")
    })
  },

  logout () {
    store.commit("logout")
    localStorage.isSignIn = 'false'
    // ### if you need to logout from keycloak, use keycloak.logout() ###
    keycloak.logout()
  },

  onChange () {
  }
}
